/* eslint-disable import/no-anonymous-default-export */
import React, { PureComponent } from "react";

import { Redirect, Route, RouteProps } from "react-router-dom";

type Props = {
  component: any;
  isLoggedIn: boolean;
  isInterviewer: boolean;
  appProps?: object;
} & RouteProps;

export default class extends PureComponent<Props> {
  render() {
    const {
      component: C,
      isLoggedIn,
      appProps,
      isInterviewer,
      ...routerProps
    } = this.props;
    return (
      <Route
        {...routerProps}
        render={props =>
          isLoggedIn ? (
            <Redirect
              to={{
                pathname: isInterviewer
                  ? "/recruit/initial-interview"
                  : "/recruit/new-applicants",
                state: { from: props.location },
              }}
            />
          ) : (
            <C {...props} {...appProps} />
          )
        }
      />
    );
  }
}
